import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {ListStaffRequest, ListStaffResponse, Paginated} from './types'

export interface List<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const list: List<ListStaffRequest, Paginated<ListStaffResponse>> = (
  http,
  params,
) => {
  const {ClientID, SeasonID, Status, PageNumber, PageSize} = params

  const path = '/v0/staff'

  const queryParams: string[] = []
  if (ClientID !== undefined) queryParams.push(`clientid=${ClientID}`)
  if (SeasonID !== undefined) queryParams.push(`seasonid=${SeasonID}`)
  if (Status !== undefined) queryParams.push(`status=${Status}`)
  if (PageNumber !== undefined) queryParams.push(`pagenumber=${PageNumber}`)
  if (PageSize !== undefined) queryParams.push(`pagesize=${PageSize}`)
  const query = `?${queryParams.join('&')}`

  return http.request<Paginated<ListStaffResponse>>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
